import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TopNavCloseWhiteIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.984 6.28221L13.416 11.8502L18.984 17.4182L17.568 18.8342L12 13.2662L6.43199 18.8342L5.01599 17.4182L10.584 11.8502L5.01599 6.28221L6.43199 4.86621L12 10.4342L17.568 4.86621L18.984 6.28221Z'
                fill='currentColor'
            />
        </>
    ),
})

TopNavCloseWhiteIcon.displayName = 'TopNavCloseWhiteIcon'
